"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _xDataGrid = require("@mui/x-data-grid");
var _ListItemText = _interopRequireDefault(require("@gogame/ui/ListItemText"));
var _MenuItem = _interopRequireDefault(require("@gogame/ui/MenuItem"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ColumnManagement(props) {
  var colDef = props.colDef,
    onClick = props.onClick,
    onCollapse = props.onCollapse;
  var apiRef = (0, _xDataGrid.useGridApiContext)();
  var rootProps = (0, _xDataGrid.useGridRootProps)();
  // const theme = useTheme();

  var pinColumn = _react["default"].useCallback(function (event) {
    apiRef.current.pinColumn(colDef.field, 'left');
    onClick(event);
  }, [apiRef, colDef.field, onClick]);
  var unpinColumn = function unpinColumn(event) {
    apiRef.current.unpinColumn(colDef.field);
    onClick(event);
  };
  var side = apiRef.current.isColumnPinned(colDef.field);
  var collapseColumn = function collapseColumn(event) {
    onCollapse(colDef);
    onClick(event);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
    children: [colDef.pinnable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
      onClick: side ? unpinColumn : pinColumn,
      sx: {
        padding: '6px 12px'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText["default"], {
        children: " ".concat(side ? 'Unpin' : 'Pin', " column")
      })
    }) : null, colDef.collapsible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], {
      onClick: collapseColumn,
      sx: {
        padding: '6px 12px'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText["default"], {
        children: "Collapse column"
      })
    }) : null]
  });
}
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(ColumnManagement);